import { render, staticRenderFns } from "./question-box.vue?vue&type=template&id=0bea9179&scoped=true"
import script from "./question-box.vue?vue&type=script&lang=js"
export * from "./question-box.vue?vue&type=script&lang=js"
import style0 from "./question-box.vue?vue&type=style&index=0&id=0bea9179&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bea9179",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bea9179')) {
      api.createRecord('0bea9179', component.options)
    } else {
      api.reload('0bea9179', component.options)
    }
    module.hot.accept("./question-box.vue?vue&type=template&id=0bea9179&scoped=true", function () {
      api.rerender('0bea9179', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taxLaw/home/chat/question-box.vue"
export default component.exports